import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../pages/layout";
import Home from "../pages/home/page";
import Catalog from "../pages/catalog/page";
import Read from "../pages/read/page";
import About from "../pages/about/page";
import Faq from "../pages/faq/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "catalog", element: <Catalog /> },
      { path: "read/:id", element: <Read /> },
      { path: "about", element: <About /> },
      { path: "faq", element: <Faq /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;